import { styled } from '@mui/material'
import { TableCell as BaseTableCell } from '@chilecompra/react-kit/components'

export const Content = styled('section')`
  font-size: 14px;
  line-height: 18px;
  overflow-x: auto;
  padding-bottom: 10px;
  padding-top: 24px;
  width: 100%;
`

export const TableCell = styled(BaseTableCell)`
  &.MuiTableCell-root {
    padding: ${props => props.padding && `${props.padding} !important`};
  }
`
